<script setup>
const emit = defineEmits(['redirect']);

const { t, locale } = useI18n();

// store
import wikiPageTypes from '@/constants/wiki-page-types';

const wikiStore = useWikiStore();

if (!wikiStore.countries?.data?.length) {
  await wikiStore.fetchCountries();
}

// countries data
const countriesData = computed(() => wikiStore.countries);
const filteredCountries = computed(() => {
  if (!countriesData.value?.data) return [];

  return countriesData.value.data.filter((country) => !!country.hrefs.length);
});

// selected country
const selectedCountryId = ref(filteredCountries.value?.[0]?.id);
const selectedCountryData = computed(() =>
  filteredCountries.value.find(
    (country) => country.id === selectedCountryId.value,
  ),
);

// selected page
const selectedPageTypeName = ref(undefined);
const selectedPageTypeData = ref(undefined);

watch(
  selectedCountryData,
  (data) => {
    if (!data) return;

    selectedPageTypeName.value =
      data.hrefs?.find((href) => href.type === 'routes')?.type ||
      data.hrefs[0]?.type;
  },
  { immediate: true },
);

watch(
  [selectedPageTypeName, selectedCountryId],
  async () => {
    selectedPageTypeData.value = await wikiStore.fetchPages({
      pageType: wikiPageTypes[selectedPageTypeName.value],
      limit: 8,
      locale: locale.value,
      filter: {
        countrySlug: selectedCountryData.value?.slug,
      },
    });
  },
  { immediate: true },
);
</script>

<template>
  <div class="bundles-trains-navigation">
    <BundlesTrainsNavigationColumnsCountries
      v-model="selectedCountryId"
      class="bundles-trains-navigation__column"
      :countries="filteredCountries"
    />
    <BundlesTrainsNavigationColumnsPageTypes
      v-if="selectedCountryData"
      v-model="selectedPageTypeName"
      class="bundles-trains-navigation__column"
      :title="selectedCountryData.title"
      :href="selectedCountryData.href"
      :hrefs="selectedCountryData.hrefs"
      :image="selectedCountryData.referenceImage"
      @redirect="(link) => emit('redirect', link)"
    />
    <GridsTrainPages
      v-if="selectedPageTypeData"
      class="bundles-trains-navigation__grid"
      :title="
        t(`wiki.pages.popularTitles.${selectedPageTypeName}`, {
          country: selectedCountryData.title,
        })
      "
      :pages="selectedPageTypeData.data"
      :country-slug="selectedCountryData.slug"
      :page-type="selectedPageTypeName"
      @redirect="(link) => emit('redirect', link)"
    />
  </div>
</template>

<style scoped lang="scss">
.bundles-trains-navigation {
  display: flex;
  gap: em(12);
  padding: em(14);
  background-color: $color-white;
  border-radius: em(13);

  &__column {
    flex-shrink: 0;
    width: em(463);
    height: 100%;
  }

  &__grid {
    width: 100%;
  }
}
</style>
